import { cn } from "@/utils/cn";

const GradientBar = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn("h-1 w-full md:h-1", className)}
      style={{
        background:
          "linear-gradient(270deg, #7E68B0 -3.96%, #008AD2 20.51%, #21B24B 42.89%, #FFC40E 64.99%, #F6821F 87.25%, #EF4023 109.23%, #7E68B0 128.71%)",
      }}
    />
  );
};

export default GradientBar;
